import { MarketCountryCode } from '@axo/shared/types';

export const UNSECURED_LOAN_AMOUNT_LIMITS: Record<
  MarketCountryCode,
  { min: number; max: number; step: number }
> = {
  [MarketCountryCode.Finland]: { min: 1, max: 70_000, step: 1 },
  [MarketCountryCode.Norway]: { min: 1, max: 800_000, step: 1 },
  [MarketCountryCode.Sweden]: { min: 1, max: 800_000, step: 1 },
  [MarketCountryCode.Denmark]: { min: 1_000, max: 600_000, step: 1_000 },
};

export const SECURED_LOAN_AMOUNT_LIMITS: Record<
  MarketCountryCode,
  { min: number; max: number; step: number }
> = {
  [MarketCountryCode.Finland]: { min: 1, max: 20_000_000, step: 1 },
  [MarketCountryCode.Norway]: { min: 1, max: 20_000_000, step: 1 },
  [MarketCountryCode.Sweden]: { min: 1, max: 20_000_000, step: 1 },
  [MarketCountryCode.Denmark]: { min: 1_000, max: 20_000_000, step: 1_000 },
};
